import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useComboboxContext } from './Combobox';
export default function ComboboxSelectedList() {
    var _a = useComboboxContext(), value = _a.value, onChange = _a.onChange, testSelector = _a.testSelector, handleSelect = _a.handleSelect;
    var handleChange = function (item) {
        onChange(item, true);
        if (handleSelect) {
            handleSelect(item);
        }
    };
    return value && value.length ? (_jsx("div", { className: "w-auto", children: _jsx("ul", { className: "p-0 pt-4 m-0 flex flex-col gap-2", "data-cy": "".concat(testSelector, "-selected-list"), children: Array.isArray(value) &&
                value
                    .slice()
                    .sort(function (a, b) { return a.label.localeCompare(b.label); })
                    .map(function (item) { return (_jsxs("li", { className: "flex max-w-max w-auto rounded-2xl items-center text-xs py-1 px-2.5 m-0 text-zinc-800 bg-sky-100", children: [item.label, _jsx("span", { className: "cursor-pointer ml-2 bg-sky-500 text-white rounded-full w-4 h-4 flex items-center justify-center", onClick: function () { return handleChange(item); }, children: "\u2014" })] }, item.value)); }) }) })) : null;
}
